import React, { useEffect, useState } from 'react';
import { loadFull } from "tsparticles";
import { useCallback } from "react";
import Particles from "react-tsparticles";
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import {FaForward,FaGithub,FaArrowAltCircleLeft} from 'react-icons/fa';
import {AiFillEye} from 'react-icons/ai';
import { useParams } from 'react-router-dom';
import { client, urlFor } from '../../Client';
import YouTube from "react-youtube";
import './ProjectDetails.css';
import snail from '../../assets/loading.gif';
var getYouTubeID = require("get-youtube-id");


const ProjectDetails = () => {
    
    const particlesInit = useCallback(async (engine) => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
      }, []);
      
      const particlesLoaded = useCallback(async (container) => {
        await console.log(container);
      }, []);
    const[activeFilter,setActiveFilter] = useState('All');
    const [works,setWorks]= useState([]);
    const [loading,setLoading] = useState(true);
    const [filterWork,setFilterWork] = useState({});
    const {projectId} = useParams();
    const[tags,setTags] = useState([]);
    console.log(projectId);

    useEffect(()=>{
        const query = '*[_type=="works"]';

        client.fetch(query)
        .then((data)=>{
            setWorks(data);
            setFilterWork(data.find((work) => work._id === projectId));
            setLoading(false);
            // setTags(data.tags.filter(item=>item  !=='All'));
        })
    },[projectId]);

   const {name,title,coverPic,youtubeLink,liveLink,clientLink,serverLink,imgUrl,description,mockUp,slogan} = filterWork;
   console.log(coverPic);
   const id=getYouTubeID(youtubeLink);
   const opts = {
   height: "390",
   width: "640",
   playerVars: {
     // https://developers.google.com/youtube/player_parameters
     autoplay: 1
   }
 };
 
   if(loading)
   {
    return <div className='loading flex justify-center items-center'><img src={snail} alt="" /></div>
   }

   
  
 

  const handleClickVisit = () => {
    window.open(liveLink);
  };
  
  const handleClickGitHub = () => {
    window.open(clientLink);
  };
 
    return (
        <div className=''>
                  <Particles
                className=''
                    id="tsparticles"
                    init={particlesInit}
                    loaded={particlesLoaded}
                    options={{
                        background: {
                            color: {
                                value: "#000",
                            },
                        },
                        fpsLimit: 120,
                        interactivity: {
                            events: {
                                onClick: {
                                    enable: true,
                                    mode: "push",
                                },
                                onHover: {
                                    enable: false,
                                    mode: "repulse",
                                },
                                resize: true,
                            },
                            modes: {
                                push: {
                                    quantity: 5,
                                },
                                repulse: {
                                    distance: 100,
                                    duration: 0.9,
                                },
                            },
                        },
                        particles: {
                            color: {
                                value: ["#BD10E0","#FFD300","#FF0000","#31a324","#2426a3"],
                            },
                            links: {
                                color: {
                                    value: ["#BD10E0","#FFD300","#FF0000","#31a324","#2426a3"],
                                },
                                distance: 100,
                                enable: true,
                                opacity: 0.5,
                                width: 2,
                            },
                            collisions: {
                                enable: false,
                            },
                            move: {
                                directions: "none",
                                enable: true,
                                outModes: {
                                    default: "bounce",
                                },
                                random: true,
                                speed:2,
                                straight: true,
                            },
                            number: {
                                density: {
                                    enable: true,
                                    area: 800,
                                },
                                value: 100,
                            },
                            opacity: {
                                value: 0.9,
                            },
                            shape: {
                                type: "circle",
                            },
                            size: {
                                value: { min: 1, max: 3 },
                            },
                        },
                        detectRetina: true,
                    }}
                />
            <div className='projectDetails min-h-screen flex justify-center items-center text-white bg-black'>
          
            <div className='container'>
              <div className='my-5'>
              <h2 className='title uppercase text-white'>{name.toUpperCase()}</h2>
              <h5 className='text-center'>{title}</h5>
              </div>
              {
                youtubeLink ?
                <div className='youtube w-full'>
                <div>
                <YouTube videoId={id} opts={opts}  />
                </div>
              </div>
              :
              <div className='youtube mockup '>
                <img  className='img-fluid w-1/2' src={urlFor(mockUp)} alt="" />
              </div>
              }
              <div className = 'row gx-5 mt-5'>
                  <div className= 'col-12 col-lg-6 h-96'>
                  <Carousel fade>
                    {
                        imgUrl?.map((img,index)=>
                        <Carousel.Item>
                        <img
                            className="d-block w-100"
                            src={urlFor(img)}
                            alt="First slide"
                        />
                        </Carousel.Item>
                        )
                    }
  </Carousel>
                  </div>
                  <div className= 'col-12 col-lg-6'>
                      <div className='project-details'>
                          <h2 className='mt-2'>{name}</h2>
                          <div className='w-3/4'>
                          <p >{slogan}</p>
                          </div>
                          <Button><a href={liveLink} target="_blank"><AiFillEye /> Visit</a></Button>
                          {
                            serverLink ? 
                            <> 
                            <Button ><a href={clientLink} target="_blank"><FaGithub /> Client </a></Button>
                            <Button ><a href={serverLink} target="_blank"><FaGithub /> Server </a></Button>
                            </>
                            :
                            <Button >
                                <a href={clientLink} target="_blank"><FaGithub /> Github </a></Button>               
                          }
                          <div className="app__work-filter flex justify-center items-center">
                            {tags.map((item, index) => (
                                <div
                                key={index}
                                className="app__work-filter-item app__flex p-text "
                                >
                                {item}
                                </div>
          ))}
        </div>
                         
                      </div>
                  </div>
                  
              </div>
              <div className='project-details'>
                <h2 className='mt-4'>OverView Project</h2>
                          {
                            description?.map((des,index)=>
                            <h3 className='my-2 leading-snug' key={index}><FaForward className="mx-2"/>{des}</h3>
                            )
                          }
              </div>
              <Link  to ='/'><Button className='mt-5'><FaArrowAltCircleLeft className='mx-2'/> Back </Button></Link>
              
          </div>
        </div>
        </div>
        
    );
};

export default ProjectDetails;